module.exports = __webpack_public_path__ + "img/ico_operatore.db5b860b.png";